import React from "react";
import { Link } from "react-router-dom";
import "./album-card.css";

function ImageAlbumCover(props) {
    var sizes = {
        'large': {width: '376px', height: '520px'},
        'medium' : {width: '200px', height: '267px'},
        'compact': {width: '140px', height: '187px'}
    }

	return (
		<>
			<div className="album-card">
				<div className="album-image-container">
					<Link to={props.link} style={{ color: "black", textDecoration: "none" }} className="album-image-link">
						<img
							src={props.src}
							className="album-image"
							alt={props.alt}
							style={sizes[props.size]}
						/>
					</Link>
				</div>
                <Link to={props.link} style={{ color: "black", textDecoration: "none" }} className="album-title-link">
				<div className="album-title">{props.gal}</div>
            
			</Link>
			</div>
			
		</>
	);
}

export default ImageAlbumCover;
